// extracted by mini-css-extract-plugin
export const action = "Alert__action__+Er60";
export const alert = "Alert__alert__NXQ4O";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const content = "Alert__content__Uwdu8";
export const danger = "Alert__danger__lKQ1+";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const success = "Alert__success__cTVBW";
export const warning = "Alert__warning__pGwHB";